import { system } from '../../tokens/system.stylex'
import { type CssValue } from './extendStyles'

export const calcUnit = (value: CssValue) => typeof value === 'number' ? `calc(${system.unit} * ${value})` : value
